import { modal } from "../components/modal";

export default function form() {
  const form = document.querySelector("#form");

  // console.log(form)

  if (!form) return;

  const email = form.querySelector('input[type="email"]');
  const tel = form.querySelector('input[type="tel"]');
  const firstName = form.querySelector('input[name="first_name"]');
  const lastName = form.querySelector('input[name="last_name"]');
  const check = form.parentElement?.querySelector(".checkbox");
  const submit = form.parentElement?.querySelector('button[type="submit"]');

  const validate = (e) => {
    e.preventDefault();
    let reg;
    var er = 0;
    // let reg = /^\+?(\d{1,3})?[- .]?\(?(?:\d{2,3})\)?[- .]?\d\d\d[- .]?\d\d[- .]?\d\d$/;
    // value in range from 11 to 20
    // let reg = /^\d{11,20}$/;
    // if (!reg.test(tel.value)) {
    //   tel.style.background = 'rgba(241, 62, 51, 0.5)'
    //   tel.focus();
    //   tel.addEventListener('input', () => {
    //     tel.style.background = 'none'
    //   })
    //   er++;
    // } else {
    // }
    reg = /\w+@\w+\.\w{2,20}/gi;
    if (!reg.test(email.value)) {
      email.focus();
      email.style.background = "rgba(241, 62, 51, 0.5)";
      email.addEventListener("input", () => {
        email.style.background = "none";
      });
      er++;
    } else {
    }
    reg = /^[a-zA-Zа-яА-Я'][a-zA-Zа-яА-Я-' ]+[a-zA-Zа-яА-Я']?$/u;
    if (firstName.value.length < 2 || !reg.test(firstName.value)) {
      firstName.focus();
      firstName.style.background = "rgba(241, 62, 51, 0.5)";
      firstName.addEventListener("input", () => {
        firstName.style.background = "none";
      });
      er++;
    } else {
    }
    if (lastName.value.length < 2 || !reg.test(lastName.value)) {
      lastName.focus();
      lastName.style.background = "rgba(241, 62, 51, 0.5)";
      lastName.addEventListener("input", () => {
        lastName.style.background = "none";
      });
      er++;
    } else {
    }

    console.log(er, "er");

    if (!er) {
      let formData = new FormData(form);
      // formData.append('action',  'sendApplication');

      sendForm(formData, "/wp-admin/admin-ajax.php", (error, response) => {
        if (error) {
          showError();
        } else {
          console.log(response);
          // thank();
        }
      });

      form.querySelectorAll(".input-shell input").forEach((el) => {
        el.value = "";
      });
      //check.checked = false;
      submit.disabled = true;
    }
  };

  if (form) {
    let checkCheck = () => {
      if (check.checked) {
        submit.disabled = false;
      } else {
        submit.disabled = true;
      }
    };
    checkCheck();
    check.addEventListener("change", checkCheck);
    form.addEventListener("submit", validate);
  }

  function thank() {
    let modals = document.querySelectorAll(".modal");

    modals.forEach((modal) => {
      // if (modal.dataset.modal == 'main') {
      //   modal.classList.remove('modal--active');
      // } else {
      //   modal.classList.add('modal--active');
      // }
      if (modal.dataset.modal !== "success") {
        modal.classList.remove("modal--active");
      } else {
        modal.classList.add("modal--active");
      }
    });
  }

  function showError() {
    let modals = document.querySelectorAll(".modal");

    modals.forEach((modal) => {
      if (modal.dataset.modal !== "fail") {
        modal.classList.remove("modal--active");
      } else {
        modal.classList.add("modal--active");
      }
    });
  }

  function sendForm(formData, url, callback) {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        try {
          const response = JSON.parse(xhr.responseText);
          callback(null, response);
        } catch (error) {
          callback(error, null);
        }
      }
    };
    xhr.onerror = function () {
      callback(new Error("Network error"), null);
    };
    xhr.send(formData);
    thank();
  }
}
